import React from 'react';
import { useDispatch } from 'react-redux';

import { Utils } from 'app/main/components';
import CompaniesMap from 'app/main/modules/companies/components/CompaniesMap';

export default function CommercialCampaignsDetailsSectionMap({ cmcpUid }: { cmcpUid: string }) {
	const dispatch = useDispatch();

	const [companies, setCompanies] = React.useState<any[]>([]);

	React.useEffect(() => {
		Utils.executeStored({
			action: 'st_commercialcampaigns_rows_list',
			dispatch,
			params: {
				n_page: 1,
				n_rows: 1000, // TODO: paginare?
				filters: [
					{
						filt_field: 'cmrw_cmcp_uid',
						filt_clause: 'equals',
						filt_value: cmcpUid
					},
					{
						filt_field: 'cmrw_table',
						filt_clause: 'equals',
						filt_value: 'companies'
					}
				]
			},
			successHandler: response => {
				setCompanies(response.data.list || []);
			}
		});
	}, [dispatch, cmcpUid]);

	return <CompaniesMap companies={companies} />;
}
